import React from "react";
import { PrimaryButton } from "../buttons";
import Modal from "../Modal";
import Text from "../edu/Text";
import "./SaveEntryModal.scss";

const NoBabyModal = props => {
  const {
    noBabiesModal,
    setNoBabiesModal,
    openBabyCreateModal
  } = props;

  return (
    <Modal
      isOpen={noBabiesModal}
      onRequestClose={() => setNoBabiesModal(false)}
    >
      <h5 className="saveentry-modal__title">No Babies Added</h5>
      <Text className="saveentry-modal__text">
        Sorry, you don't have any babies added to your account yet.
      </Text>
      <div className="saveentry-modal__footer">
        <PrimaryButton
          colorScheme="blue"
          label='Add a New Baby'
          type="button"
          onClick={() => {
            setNoBabiesModal(false);
            openBabyCreateModal();
          }}
        />
      </div>
    </Modal>
  );
};

export default NoBabyModal;
